module.exports = __webpack_public_path__ + "static/media/ic_player_fullscreen.03a3ab48.svg";